type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const CodOutStatus = Object.freeze({
  WAITING: 1 as const,
  PAID: 2 as const,
});

export type CodOutStatus = EnumLiteralsOf<typeof CodOutStatus>;
